import Seo from "@/components/Seo";
import { PageHero } from "@/components/Section";
import { COMPANY } from "@/data/site";

function LegalLayout({ testid, title, description, eyebrow, lines, sections }) {
  return (
    <>
      <Seo title={title} description={description} />
      <PageHero testid={testid} dark={false} eyebrow={eyebrow} lines={lines} lead="Last updated: July 2026." />
      <section className="bg-mist">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
          <div className="space-y-10">
            {sections.map((s) => (
              <article key={s.heading}>
                <h2 className="font-display text-xl font-bold tracking-tight text-slate-900">{s.heading}</h2>
                <p className="mt-3 text-base leading-relaxed text-slate-600">{s.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export function Privacy() {
  return (
    <LegalLayout
      testid="privacy-page"
      eyebrow="Legal"
      lines={["Privacy Policy."]}
      title={`Privacy Policy — ${COMPANY.name}`}
      description="How BNM Sustainable Energy Limited collects, uses and protects personal information submitted through this website."
      sections={[
        {
          heading: "1. Who We Are",
          body: `${COMPANY.name} ("BNM", "we", "us") is a clean-energy technology company located at ${COMPANY.addressLines.join(", ")}. This policy explains how we handle personal information submitted through this website.`,
        },
        {
          heading: "2. Information We Collect",
          body: "When you submit the contact form, we collect your name, organization (optional), email address, phone number (optional), inquiry type and message. We do not collect payment information or use advertising trackers on this website.",
        },
        {
          heading: "3. How We Use Information",
          body: "We use submitted information solely to respond to your inquiry and manage our relationship with you. We do not sell, rent or share your personal information with third parties for marketing purposes.",
        },
        {
          heading: "4. Data Retention & Security",
          body: "Inquiry records are retained only as long as needed to handle your request and are stored with appropriate technical safeguards. Access is limited to authorised BNM personnel.",
        },
        {
          heading: "5. Your Rights",
          body: `You may request access to, correction of, or deletion of your personal information at any time by contacting us at ${COMPANY.emails[0]} or ${COMPANY.emails[1]}, or by phone at ${COMPANY.phoneDisplay}.`,
        },
        {
          heading: "6. Changes to This Policy",
          body: "We may update this policy as the website evolves. Material changes will be reflected on this page with an updated date.",
        },
      ]}
    />
  );
}

export function Terms() {
  return (
    <LegalLayout
      testid="terms-page"
      eyebrow="Legal"
      lines={["Terms of Use."]}
      title={`Terms of Use — ${COMPANY.name}`}
      description="Terms governing the use of the BNM Sustainable Energy Limited website."
      sections={[
        {
          heading: "1. Acceptance of Terms",
          body: `By accessing this website you agree to these Terms of Use. This website is operated by ${COMPANY.name}, located at ${COMPANY.addressLines.join(", ")}.`,
        },
        {
          heading: "2. Informational Content",
          body: "Content on this website is provided for general information. Product development status, specifications and roadmaps describe work in progress and may change. Where specifications are not final, they are marked as under development.",
        },
        {
          heading: "3. Intellectual Property",
          body: `The BNM name, logo and website content are the property of ${COMPANY.name} and may not be reproduced without written permission. Third-party imagery is used under licence and marked as representative where applicable.`,
        },
        {
          heading: "4. Acceptable Use",
          body: "You agree not to misuse this website, attempt to gain unauthorised access to its systems, or submit unlawful, harmful or misleading content through its forms.",
        },
        {
          heading: "5. Limitation of Liability",
          body: "This website is provided 'as is'. To the maximum extent permitted by law, BNM is not liable for damages arising from the use of, or inability to use, this website.",
        },
        {
          heading: "6. Contact",
          body: `Questions about these terms may be sent to ${COMPANY.emails[0]} or ${COMPANY.emails[1]}, or by phone at ${COMPANY.phoneDisplay}.`,
        },
      ]}
    />
  );
}
